import { useMutation } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'

export type KomboActivationResponse = {
  connection_complete: boolean;
}

export function useActivateKomboIntegration () {
  return useMutation<KomboActivationResponse, GrapeAPIErrorType, { token: string }>({
    mutationFn: async ({ token }: { token: string }) => {
      const response = await fetchWithHeaders(
        '/api/web/payroll/kombo/activate',
        {
          method: 'POST',
          body: JSON.stringify({ token }),
        }
      )

      if (!response.ok) {
        const errors = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json()
    },
  })
}
